export const moduleConfig = {
    entityKey: 'subscriptions',
    basePath: '/customer-subscriptions',
    titles: {
        singular: 'Subscription',
        plural: 'Customer Subscriptions'
    }
}
